export const toSnakeCase = (str: string) : string => {
    return str
        .replace(/\s+/g, '_')
        .toLowerCase()
        .replace(/^_+|_+$/g, '');
}

export const toCleanSnakeCase = (str: string): string => {
    return toSnakeCase(cleanSpecialChars(str));
}

export const cleanSpecialChars = (str: string) : string => {
    return str
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9_-]+/g, '');
}